import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";
import { jsonToQuery } from "@/utils/queryHelper";

/**
 * Ferry Company Service
 * Feribot firma detay ve liste API'leri için servis
 */
export const ferryCompanyService = {
  /**
   * Feribot firmaları listesini getir
   * @param {Object} payload - API payload
   * @param {string} payload.CompanyFirstLetter - Firma ilk harfi (örn: "A", boş string tümü)
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "CompanyFirstLetter": "",
   *   "LanguageCode": "tr"
   * }
   */
  getCompanyList: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.company.getCompanyList}?${jsonToQuery(payload)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma listesi hakkında içeriklerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getCompanyListAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.company.getCompanyListAbout,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma içeriğini getir (Company list sayfası için)
   * @param {Object} query - API query
   * @param {string} query.languageCode - Dil kodu (örn: "TR", "EN")
   * @param {string} query.currencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getCompanyContent: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.company.getCompanyContent}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma QA içeriğini getir (FAQ için)
   * @param {Object} query - API query
   * @param {string} query.companyId - Firma ID
   * @param {string} query.languageCode - Dil kodu (örn: "tr", "en")
   * @param {string} query.currencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getCompanyQAContent: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.company.getCompanyQAContent}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Yunan adaları için popüler firmaları getir
   * @param {Object} query - API query
   * @param {string} query.languageCode - Dil kodu (örn: "TR", "EN")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getPopularCompaniesGreeceIslands: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.company.getPopularCompaniesGreeceIslands}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Kıbrıs için popüler firmaları getir
   * @param {Object} query - API query
   * @param {string} query.languageCode - Dil kodu (örn: "TR", "EN")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getPopularCompaniesCyprus: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.company.getPopularCompaniesCyprus}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),
};

export default ferryCompanyService;
